import { render } from "./titleHeader1.vue?vue&type=template&id=8965a42a"
import script from "./titleHeader1.vue?vue&type=script&lang=js"
export * from "./titleHeader1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__